import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root"
})
export class RequestedRouteService {
	private readonly storageKey = "requestedRoute";

	store(url: string): void {
		if (this.isInternalRelativePath(url)) {
			sessionStorage.setItem(this.storageKey, url);
		}
	}

	get(): string | null {
		const url = sessionStorage.getItem(this.storageKey);
		if (!url) return null;

		if (!this.isInternalRelativePath(url)) {
			this.clear();
			return null;
		}

		return url;
	}

	clear(): void {
		sessionStorage.removeItem(this.storageKey);
	}

	isInternalRelativePath(url: string | null): url is string {
		return !!url && url.startsWith("/") && !url.startsWith("//");
	}
}
